
 
 
 let run_type=2 //0开发模式 1测试模式 2正式模式
 let base ='/api'  //开发地址
 let article_url='http://article.weicistudy.com/test.html'
 let uedit_server_url='http://114.55.245.177:78/controller.ashx';//'http://localhost:3175/net/controller.ashx';
 if (run_type==1)
 {
    base = 'http://114.55.245.177:8099/api';  //测试地址
 }

 if (run_type==2)
 {
    article_url='http://article.weicistudy.com/index.html';
    base='http://push.weicistudy.com/api';  //正式环境地址
    uedit_server_url='http://uedit.weicistudy.com/controller.ashx';
 }
 export const runType=run_type;
 export const ueditServerUrl=uedit_server_url;
 export const articleUrl=article_url;
 export const existsMenuRight=base+'/account/ExistsMenuRight';
 export const requestLogin = base+'/account/login';
 export const requestMenu = base+'/account/usermenu';
 export const updatePassword = base+'/account/UpdatePassword';
 export const getUserListPage= base+'/account/UserList';
 export const addUser =  base+'/account/addUser'; 
 export const editUser =  base+'/account/editUser'; 
 export const removeUser  =  base+'/account/removeUser';
 export const batchRemoveUser =base+'/account/batchremoveUser';

 export const getRoleListPage= base+'/account/RoleList';
 export const addRole =  base+'/account/AddRole'; 
 export const editRole =  base+'/account/EditRole'; 
 export const removeRole  =  base+'/account/removeRole';
 export const batchRemoveRole =base+'/account/batchremoveRole';

 export const getUserTree= base+'/account/UserTree';
 export const getRoleTree= base+'/account/RoleTree';
 export const saveUserRole=base+'/account/SaveUserRole';
 export const getUserRole=base+'/account/GetUserRole';

 export const getRightTree= base+'/account/RightTree';
 export const saveRoleRight=base+'/account/SaveRoleRight';
 export const getRoleRight=base+'/account/GetRoleRight';
                                  
  export const getSysMenu= base+'/account/SysMenu';
  export const getMainMenuListPage= base+'/account/MainMenuList';
  export const addMainMenu= base+'/account/AddMainMenu';
  export const editMainMenu= base+'/account/EditMainMenu';
  export const removeMainMenu= base+'/account/RemoveMainMenu';
  export const batchRemoveMainMenu= base+'/account/BatchRemoveMainMenu';
  export const getParentMenu=base+'/account/ParentMenu';

  export const getItemListPage= base+'/account/ItemList';
  export const addItem= base+'/account/AddItem';
  export const editItem= base+'/account/EditItem';
  export const removeItem= base+'/account/RemoveItem';
  export const batchRemoveItem= base+'/account/BatchRemoveItem';
  export const getItemGroup=base+'/account/ItemGroupSelect';

  export const getButtonListPage= base+'/account/ButtonList';
  export const addButton= base+'/account/AddButton';
  export const editButton= base+'/account/EditButton';
  export const removeButton= base+'/account/RemoveButton';
  export const batchRemoveButton= base+'/account/BatchRemoveButton';
  export const getButtonMenu=base+'/account/ButtonMenu';


 export const getPushListPage= base+'/push/PushList';
 export const addPush =  base+'/push/PushAdd'; 
 export const editPush =  base+'/push/PushEdit'; 
 export const removePush  =  base+'/push/PushRemove';
 export const batchRemovePush =base+'/push/PushBatchRemove';
 export const getTags= base+'/push/TagKey';
 export const  getTagValues= base+'/push/TagValue';
 export const getJump=base+'/push/Jump';
 export const getJumpParams=base+'/push/JumpParams';
 export const getAppGroup=base+'/push/AppGroup';
 export const getApp=base+'/push/App';
 export const getPushBase=base+'/push/PushBase';

  export const getInfoListPage= base+'/push/InfoList';
  export const addInfo= base+'/push/InfoAdd';
  export const editInfo= base+'/push/InfoEdit';
  export const removeInfo= base+'/push/InfoRemove';
  export const batchRemoveInfo= base+'/push/InfoBatchRemove';
  export const getInfoBase=base+'/push/InfoBase';

  export const upload= base+'/push/UploadFile';
  export const imgDel= base+'/push/ImgDel';
  export const imgsDel= base+'/push/ImgsDel';


  export const uploadDiscovery= base+'/push/UploadImage';

  export const getParamListPage= base+'/base/JumpParamList';
  export const addParam= base+'/base/JumpParamAdd';
  export const editParam= base+'/base/JumpParamEdit';
  export const removeParam= base+'/base/JumpParamRemove';
  export const batchRemoveParam= base+'/base/JumpParamBatchRemove';
  //export const getParamJump=base+'/base/Jump';

  export const getArticleListPage= base+'/article/ArticleList';
  export const addArticle= base+'/article/ArticleAdd';
  export const editArticle= base+'/article/ArticleEdit';
  export const removeArticle= base+'/article/ArticleRemove';
  export const batchremoveArticle= base+'/article/ArticleBatchRemove';
  export const getArticleBase= base+'/article/ArticleBase';
  export const getArticle= base+'/article/Article';

  export const getDiscoveryGroupListPage= base+'/discovery/GroupList';
  export const addDiscoveryGroup= base+'/discovery/GroupAdd';
  export const editDiscoveryGroup= base+'/discovery/GroupEdit';
  export const removeDiscoveryGroup= base+'/discovery/GroupRemove';
  export const batchRemoveDiscoveryGroup= base+'/discovery/GroupBatchRemove';
  export const getParentGroup= base+'/discovery/GroupParent';

  export const getDiscoveryListPage= base+'/discovery/DiscoveryList';
  export const addDiscoveryInfo= base+'/discovery/DiscoveryAdd';
  export const editDiscoveryInfo= base+'/discovery/DiscoveryEdit';
  export const removeDiscoveryInfo= base+'/discovery/DiscoveryRemove';
  export const batchremoveDiscoveryInfo= base+'/discovery/DiscoveryBatchRemove';
  export const getDiscoveryInfoBase=base+'/discovery/DiscoveryBase';
  export const getWordListPage= base+'/discovery/WordList';
  export const getWordSubListPage= base+'/discovery/WordSubList';

  export const getReleaseListPage= base+'/discovery/ReleaseList';
  export const addRelease= base+'/discovery/ReleaseAdd';
  export const editRelease= base+'/discovery/ReleaseEdit';
  export const removeRelease= base+'/discovery/ReleaseRemove';
  export const batchRemoveRelease= base+'/discovery/ReleaseBatchRemove';
  export const getReleaseBase=base+'/discovery/ReleaseBase';
  export const discoveryRelease=base+'/discovery/Release';
  export const discoveryUnRelease=base+'/discovery/UnRelease';

  export const getAdListPage= base+'/discovery/AdList';
  export const addAd= base+'/discovery/AdAdd';
  export const editAd= base+'/discovery/AdEdit';
  export const removeAd= base+'/discovery/AdRemove';
  export const batchRemoveAd= base+'/discovery/AdBatchRemove';
  export const adRelease=base+'/discovery/AdRelease';
  export const adUnRelease=base+'/discovery/AdUnRelease';



  export const getMainListPage= base+'/discovery/PushSentenceList';
  export const addSentence= base+'/discovery/SentenceAdd';
  export const editSentence= base+'/discovery/SentenceEdit';
  export const removeSentence= base+'/discovery/SentenceRemove';
  export const batchRemoveSentence= base+'/discovery/SentenceBatchRemove';  
  export const sentenceRelease=base+'/discovery/SentenceRelease';
  export const sentenceUnRelease=base+'/discovery/SentenceUnRelease';
  export const getSentenceListPage= base+'/discovery/SentenceList';
  export const getSubListPage= base+'/discovery/SentenceSubList';





// WEBPACK FOOTER //
// ./src/api/api.js